export default {
  Codigo: null,
  Descripcion: '',
  AceptaNegativo: false,
  CodigoUsuarioInventario: null,
  InventarioActivo: false,
  FechaHoraInventario: null,
};
